var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.225,
    height: 10,
    viewBox: "0 0 14.225 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Page_back_web_app",
    "data-name": "Page back web app",
    d: "M9.584,4.826a.5.5,0,1,0-.717.71L12.5,9.171H.508a.5.5,0,0,0-.509.5.511.511,0,0,0,.509.509H12.5L8.867,13.809a.515.515,0,0,0,0,.717.5.5,0,0,0,.717,0l4.5-4.5a.506.506,0,0,0,0-.71Z",
    transform: "translate(0.001 -4.676)",
    fill: "#0d0d0d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightIcon);
export default __webpack_public_path__ + "static/media/arrow-right-icon.7524ec25391c7da313ca41a0880cac4f.svg";
export { ForwardRef as ReactComponent };